import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-8 space-y-5" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 md:grid-cols-4" }
const _hoisted_5 = { class: "rounded-2xl border-2 border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_6 = { class: "mt-2 text-2xl font-bold text-blue-900" }
const _hoisted_7 = { class: "rounded-2xl border-2 border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_8 = { class: "mt-2 text-2xl font-bold text-green-700" }
const _hoisted_9 = { class: "rounded-2xl border-2 border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_10 = { class: "mt-2 text-2xl font-bold text-amber-700" }
const _hoisted_11 = { class: "rounded-2xl border-2 border-slate-200 bg-white p-4 shadow-sm" }
const _hoisted_12 = { class: "mt-2 text-2xl font-bold text-blue-900" }
const _hoisted_13 = { class: "grid gap-3 sm:grid-cols-2 lg:grid-cols-5" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "overflow-hidden rounded-2xl border-2 border-slate-200 bg-white shadow-sm" }
const _hoisted_16 = { class: "overflow-x-auto" }
const _hoisted_17 = { class: "min-w-full text-sm" }
const _hoisted_18 = { class: "bg-white divide-y divide-slate-100" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "px-4 py-4 text-slate-500 align-middle" }
const _hoisted_22 = { class: "px-4 py-4 align-middle" }
const _hoisted_23 = { class: "font-semibold text-slate-900 whitespace-nowrap" }
const _hoisted_24 = { class: "mt-0.5 text-xs text-slate-500 whitespace-nowrap" }
const _hoisted_25 = { class: "px-4 py-4 align-middle" }
const _hoisted_26 = { class: "font-medium text-slate-900 whitespace-nowrap" }
const _hoisted_27 = { class: "text-xs text-slate-500 whitespace-nowrap" }
const _hoisted_28 = { class: "text-xs text-slate-500 whitespace-nowrap" }
const _hoisted_29 = { class: "px-4 py-4 align-middle" }
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "px-4 py-4 text-right align-middle whitespace-nowrap" }
const _hoisted_32 = { class: "font-semibold text-slate-900" }
const _hoisted_33 = { class: "text-xs text-slate-500" }
const _hoisted_34 = { class: "px-4 py-4 align-middle" }
const _hoisted_35 = { class: "space-y-1" }
const _hoisted_36 = { class: "px-4 py-4 align-middle" }
const _hoisted_37 = { class: "min-w-[170px] space-y-2" }
const _hoisted_38 = { class: "px-4 py-4 text-slate-600 align-middle whitespace-nowrap" }
const _hoisted_39 = { class: "text-xs text-slate-400" }
const _hoisted_40 = { class: "px-4 py-4 align-middle" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 1,
  class: "inline-flex h-8 min-w-[54px] items-center justify-center rounded-full bg-slate-100 px-3 text-xs font-semibold text-slate-500"
}
const _hoisted_43 = { class: "px-4 py-4 text-right align-middle whitespace-nowrap" }
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "flex flex-col items-center justify-between gap-2 border-t border-slate-100 px-6 py-4 sm:flex-row" }
const _hoisted_48 = { class: "text-xs text-slate-500" }
const _hoisted_49 = { class: "inline-flex" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { GET_TRANSACTIONS, DELETE_TRANSACTION, PUT_TRANSACTION } from '@/store/transaction.module';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';

type Merchandise = {
  id?: number;
  name?: string;
  price?: number | string | null;
};

type Transaction = {
  id: number;
  code?: string;
  publicToken?: string;
  username?: string;
  email?: string;
  noTelp?: string;
  address?: string;
  merchandiseId?: number;
  merchandises?: Merchandise;
  qty?: number;
  payment?: string | null;
  paymentMethod?: string;
  paymentStatus?: string;
  grossAmount?: number | string | null;
  status: string;
  createdAt?: string;
  updatedAt?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionView',
  setup(__props) {

const store = useStore();

const isLoading = ref(true);
const page = ref(1);
const limit = ref(10);
const search = ref('');
const paymentMethod = ref('');
const paymentStatus = ref('');
const orderStatus = ref('');
const isImageModalOpen = ref(false);
const selectedImage = ref('');
const statusDraft = ref<Record<number, string>>({});
const savingStatus = ref<Record<number, boolean>>({});
const orderStatusOptions = ['waiting', 'on process', 'on delivery', 'arrived', 'done', 'canceled', 'denied'];
const notifyStatuses = new Set(['on process', 'on delivery', 'arrived', 'done', 'canceled', 'denied']);
const orderStatusLabels: Record<string, string> = {
  waiting: 'Menunggu',
  'on process': 'Diproses',
  'on delivery': 'Dikirim',
  arrived: 'Tiba',
  done: 'Selesai',
  canceled: 'Dibatalkan',
  denied: 'Ditolak',
};
const paymentStatusLabels: Record<string, string> = {
  pending: 'Menunggu',
  settlement: 'Lunas',
  expired: 'Kedaluwarsa',
  failed: 'Gagal',
  refunded: 'Dikembalikan',
};
const pageLimitOptions = [
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
];
const paymentMethodOptions = [
  { value: '', label: 'Semua' },
  { value: 'manual', label: 'Manual' },
  { value: 'midtrans', label: 'Midtrans' },
];
const paymentStatusOptions = [
  { value: '', label: 'Semua' },
  { value: 'pending', label: 'Menunggu' },
  { value: 'settlement', label: 'Lunas' },
  { value: 'expired', label: 'Kedaluwarsa' },
  { value: 'failed', label: 'Gagal' },
  { value: 'refunded', label: 'Dikembalikan' },
];
const orderStatusSelectOptions = orderStatusOptions.map((status) => ({
  value: status,
  label: orderStatusLabels[status],
}));
const orderStatusFilterOptions = [
  { value: '', label: 'Semua' },
  ...orderStatusSelectOptions,
];
const publicAppBaseUrl = (process.env.VUE_APP_PUBLIC_APP_URL || 'https://iom-app.kirisame.jp.net').replace(/\/+$/, '');
let searchTimer: ReturnType<typeof setTimeout> | null = null;

const computedData = computed<Transaction[]>(() => {
  const transactions = store.getters.transactions;
  return Array.isArray(transactions) ? transactions : [];
});

const pagination = computed(() => store.getters.transactionPagination || {});
const startNumber = computed(() => pagination.value?.start || 1);
const paidCount = computed(() => computedData.value.filter((item) => item.paymentStatus === 'settlement').length);
const needProcessCount = computed(() => computedData.value.filter((item) => ['waiting', 'on process'].includes(item.status)).length);

const getData = async () => {
  isLoading.value = true;

  try {
    const data = await store.dispatch(GET_TRANSACTIONS, {
      data: {
        page: page.value,
        limit: limit.value,
        search: search.value || undefined,
        paymentMethod: paymentMethod.value || undefined,
        paymentStatus: paymentStatus.value || undefined,
        status: orderStatus.value || undefined,
      },
    });

    (data || []).forEach((transaction: Transaction) => {
      statusDraft.value[transaction.id] = transaction.status;
    });

    return data;
  } finally {
    isLoading.value = false;
  }
};

const refreshFromFirstPage = () => {
  page.value = 1;
  getData();
};

const onSearchInput = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(refreshFromFirstPage, 350);
};

onMounted(getData);

const openImageModal = (imageUrl: string) => {
  selectedImage.value = imageUrl;
  isImageModalOpen.value = true;
};

const closeImageModal = () => {
  isImageModalOpen.value = false;
};

const isManualProof = (payment?: string | null) => Boolean(payment) && !String(payment).startsWith('midtrans:');

const merchandiseName = (transaction: Transaction) => {
  return transaction.merchandises?.name || `Merchandise #${transaction.merchandiseId || '-'}`;
};

const formatStatus = (status?: string) => {
  if (!status) return '-';
  return orderStatusLabels[status] || status.replace(/\b\w/g, (char) => char.toUpperCase());
};

const formatNominal = (amount?: number | string | null) => {
  if (amount == null || amount === '') return '-';
  const value = Number(amount);
  if (Number.isNaN(value)) return String(amount);
  return `Rp ${value.toLocaleString('id-ID')}`;
};

const paymentMethodLabel = (method?: string) => {
  if (method === 'midtrans') return 'Midtrans';
  if (method === 'manual') return 'Manual';
  return '-';
};

const paymentStatusLabel = (status?: string) => paymentStatusLabels[status || 'pending'] || 'Menunggu';

const methodBadgeClass = (method?: string) =>
  method === 'midtrans' ? 'bg-blue-100 text-blue-700' : 'bg-slate-200 text-slate-700';

const paymentStatusBadgeClass = (status?: string) => {
  switch (status) {
    case 'settlement':
      return 'bg-green-100 text-green-700';
    case 'expired':
      return 'bg-gray-200 text-gray-700';
    case 'failed':
      return 'bg-red-100 text-red-700';
    case 'refunded':
      return 'bg-purple-100 text-purple-700';
    case 'pending':
    default:
      return 'bg-yellow-100 text-yellow-700';
  }
};

const orderStatusBadgeClass = (status?: string) => {
  switch (status) {
    case 'done':
    case 'arrived':
      return 'bg-green-100 text-green-700';
    case 'on process':
    case 'on delivery':
      return 'bg-blue-100 text-blue-700';
    case 'canceled':
    case 'denied':
      return 'bg-red-100 text-red-700';
    case 'waiting':
    default:
      return 'bg-slate-100 text-slate-700';
  }
};

const formatDate = (dateString?: string) => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
  const day = String(date.getDate()).padStart(2, '0');
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');

  return `${day} ${month} ${year}, ${hour}:${minute}`;
};

const hasStatusChanged = (item: Transaction) => {
  return Boolean(item?.id) && Boolean(statusDraft.value[item.id]) && statusDraft.value[item.id] !== item.status;
};

const trackingUrl = (item: Transaction) => {
  if (!item.publicToken) return '';
  return `${publicAppBaseUrl}/order-status?token=${encodeURIComponent(item.publicToken)}`;
};

const getErrorMessage = (error: unknown) => {
  const apiError = error as { response?: { data?: { message?: string } }; message?: string };
  return apiError?.response?.data?.message || apiError?.message || 'Terjadi kesalahan.';
};

const writeClipboard = async (text: string) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

const copyTrackingLink = async (item: Transaction) => {
  const url = trackingUrl(item);
  if (!url) {
    await Swal.fire({
      title: 'Link belum tersedia',
      text: 'Transaksi lama perlu token publik sebelum link status bisa disalin.',
      icon: 'warning',
      confirmButtonColor: '#4f46e5',
    });
    return;
  }

  try {
    await writeClipboard(url);
    await Swal.fire({
      title: 'Link tersalin',
      text: 'Link status pesanan siap dikirim ke pembeli.',
      icon: 'success',
      timer: 1600,
      showConfirmButton: false,
    });
  } catch (error) {
    await Swal.fire({
      title: 'Gagal menyalin link',
      text: url,
      icon: 'info',
      confirmButtonColor: '#4f46e5',
    });
  }
};

const saveStatus = async (item: Transaction) => {
  const nextStatus = statusDraft.value[item.id];

  if (!nextStatus || nextStatus === item.status) return;

  const confirmation = await Swal.fire({
    title: 'Update status pesanan?',
    text: notifyStatuses.has(nextStatus)
      ? 'Pembeli akan menerima notifikasi Email dan WhatsApp jika kontak tersedia.'
      : 'Status pesanan akan diperbarui.',
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#4f46e5',
    cancelButtonColor: '#6b7280',
    confirmButtonText: 'Ya, update',
    cancelButtonText: 'Batal',
  });

  if (!confirmation.isConfirmed) {
    statusDraft.value[item.id] = item.status;
    return;
  }

  savingStatus.value[item.id] = true;

  try {
    await store.dispatch(PUT_TRANSACTION, {
      id: item.id,
      data: {
        status: nextStatus,
      },
    });
    await getData();
    await Swal.fire({
      title: 'Berhasil',
      text: 'Status pesanan berhasil diperbarui.',
      icon: 'success',
      confirmButtonColor: '#4f46e5',
    });
  } catch (error) {
    statusDraft.value[item.id] = item.status;
    await Swal.fire({
      title: 'Gagal update status',
      text: getErrorMessage(error),
      icon: 'error',
      confirmButtonColor: '#4f46e5',
    });
  } finally {
    savingStatus.value[item.id] = false;
  }
};

const deleteItem = async (id: number) => {
  const confirmation = await Swal.fire({
    title: 'Hapus transaksi?',
    text: 'Data transaksi yang dihapus tidak bisa dikembalikan.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ya, hapus',
    cancelButtonText: 'Batal',
  });

  if (!confirmation.isConfirmed) return;

  try {
    await store.dispatch(DELETE_TRANSACTION, { id });
    await getData();
    await Swal.fire({
      title: 'Terhapus',
      text: 'Transaksi berhasil dihapus.',
      icon: 'success',
      confirmButtonColor: '#4CAF50',
      confirmButtonText: 'OK',
    });
  } catch (error) {
    await Swal.fire({
      title: 'Gagal hapus transaksi',
      text: getErrorMessage(error),
      icon: 'error',
      confirmButtonColor: '#4f46e5',
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "transaksi-merchandise" }),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/60",
          onClick: closeImageModal
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Bukti Bayar",
            class: "max-w-full max-h-full rounded-md shadow-lg"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _cache[21] || (_cache[21] = _createStaticVNode("<section class=\"relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6\"><div class=\"absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10\"></div><div class=\"absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10\"></div><div class=\"relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between\"><div><h1 class=\"text-2xl font-bold md:text-4xl\">Transaksi Merchandise</h1><p class=\"mt-2 max-w-2xl text-sm leading-relaxed text-blue-100\"> Kelola pembayaran, bukti transfer, dan status pengiriman pesanan merchandise. </p></div><div class=\"rounded-2xl bg-white/10 px-4 py-3 text-sm text-blue-50\"><p class=\"text-sm font-medium text-blue-100\">Status pesanan</p><p class=\"mt-1 font-semibold\">Ubah dari dropdown, lalu klik Simpan.</p></div></div></section>", 1)),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Total Transaksi", -1)),
          _createElementVNode("p", _hoisted_6, _toDisplayString(pagination.value?.totalEntries || computedData.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Lunas", -1)),
          _createElementVNode("p", _hoisted_8, _toDisplayString(paidCount.value), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Perlu Diproses", -1)),
          _createElementVNode("p", _hoisted_10, _toDisplayString(needProcessCount.value), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Halaman", -1)),
          _createElementVNode("p", _hoisted_12, _toDisplayString(pagination.value?.currentPage || 1) + " / " + _toDisplayString(pagination.value?.totalPages || 1), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Per halaman", -1)),
          _createVNode(AppSelect, {
            modelValue: limit.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event)),
            options: pageLimitOptions,
            onChange: refreshFromFirstPage
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Metode Bayar", -1)),
          _createVNode(AppSelect, {
            modelValue: paymentMethod.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentMethod).value = $event)),
            options: paymentMethodOptions,
            onChange: refreshFromFirstPage
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status Bayar", -1)),
          _createVNode(AppSelect, {
            modelValue: paymentStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentStatus).value = $event)),
            options: paymentStatusOptions,
            onChange: refreshFromFirstPage
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Status Pesanan", -1)),
          _createVNode(AppSelect, {
            modelValue: orderStatus.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((orderStatus).value = $event)),
            options: orderStatusFilterOptions,
            onChange: refreshFromFirstPage
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1.5 text-sm font-semibold text-slate-900" }, "Cari", -1)),
          _createElementVNode("div", _hoisted_14, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-2.5" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                class: "w-4 h-4 text-slate-400 fill-current"
              }, [
                _createElementVNode("path", { d: "M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z" })
              ])
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
              onInput: onSearchInput,
              placeholder: "Kode, nama, email...",
              class: "block w-full rounded-lg border border-slate-200 bg-white py-2 pl-8 pr-3 text-sm text-slate-700 placeholder-slate-400 transition-all focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
            }, null, 544), [
              [_vModelText, search.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "bg-blue-900" }, [
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "No"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Pesanan"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Pembeli"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Alamat"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Total"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Pembayaran"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Status Pesanan"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Tanggal"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-left text-blue-100" }, "Bukti"),
                _createElementVNode("th", { class: "px-4 py-3.5 text-sm font-semibold text-right text-blue-100" }, "Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_18, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (c) => {
                      return _createElementVNode("td", {
                        key: c,
                        class: "px-4 py-4"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("div", { class: "h-4 w-full max-w-[120px] animate-pulse rounded bg-slate-100" }, null, -1)
                      ]))])
                    }), 64))
                  ]))
                : (computedData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("td", {
                        colspan: "10",
                        class: "px-4 py-12 text-sm text-center text-slate-400 italic"
                      }, "Belum ada transaksi merchandise.", -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(computedData.value, (u, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: u.id,
                        class: "transition-colors hover:bg-blue-50/40"
                      }, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(startNumber.value + index), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(u.code || '-'), 1),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(merchandiseName(u)) + " x " + _toDisplayString(u.qty || 0), 1)
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("p", _hoisted_26, _toDisplayString(u.username || '-'), 1),
                          _createElementVNode("p", _hoisted_27, _toDisplayString(u.email || '-'), 1),
                          _createElementVNode("p", _hoisted_28, _toDisplayString(u.noTelp || '-'), 1)
                        ]),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("p", {
                            class: "max-w-[240px] text-slate-600 line-clamp-2",
                            title: u.address || '-'
                          }, _toDisplayString(u.address || '-'), 9, _hoisted_30)
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(formatNominal(u.grossAmount)), 1),
                          _createElementVNode("p", _hoisted_33, _toDisplayString(u.qty || 0) + " item", 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("span", {
                              class: _normalizeClass([methodBadgeClass(u.paymentMethod), "inline-block px-2 py-0.5 text-xs font-medium rounded-full"])
                            }, _toDisplayString(paymentMethodLabel(u.paymentMethod)), 3),
                            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass([paymentStatusBadgeClass(u.paymentStatus), "inline-block px-2 py-0.5 text-xs font-medium rounded-full capitalize"])
                            }, _toDisplayString(paymentStatusLabel(u.paymentStatus)), 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(AppSelect, {
                              modelValue: statusDraft.value[u.id],
                              "onUpdate:modelValue": ($event: any) => ((statusDraft.value[u.id]) = $event),
                              disabled: savingStatus.value[u.id],
                              options: _unref(orderStatusSelectOptions)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options"]),
                            _createElementVNode("span", {
                              class: _normalizeClass(["inline-block px-2 py-0.5 text-xs font-medium rounded-full", orderStatusBadgeClass(statusDraft.value[u.id] || u.status)])
                            }, _toDisplayString(formatStatus(statusDraft.value[u.id] || u.status)), 3)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("p", null, _toDisplayString(formatDate(u.createdAt)), 1),
                          _createElementVNode("p", _hoisted_39, "Update: " + _toDisplayString(formatDate(u.updatedAt)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_40, [
                          (isManualProof(u.payment))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "rounded-full bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100",
                                onClick: ($event: any) => (openImageModal(u.payment || ''))
                              }, " Lihat ", 8, _hoisted_41))
                            : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(u.paymentMethod === 'midtrans' ? 'MID' : '-'), 1))
                        ]),
                        _createElementVNode("td", _hoisted_43, [
                          _createElementVNode("button", {
                            type: "button",
                            disabled: savingStatus.value[u.id] || !hasStatusChanged(u),
                            class: "mr-2 rounded-full bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-slate-300",
                            onClick: _withModifiers(($event: any) => (saveStatus(u)), ["prevent"])
                          }, _toDisplayString(savingStatus.value[u.id] ? 'Saving...' : 'Simpan'), 9, _hoisted_44),
                          (u.publicToken)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "mr-2 rounded-full bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100",
                                onClick: _withModifiers(($event: any) => (copyTrackingLink(u)), ["prevent"])
                              }, " Salin Link ", 8, _hoisted_45))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-full bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100",
                            onClick: _withModifiers(($event: any) => (deleteItem(u.id)), ["prevent"])
                          }, " Hapus ", 8, _hoisted_46)
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("span", _hoisted_48, " Menampilkan " + _toDisplayString(pagination.value?.start || 0) + "-" + _toDisplayString(pagination.value?.end || 0) + " dari " + _toDisplayString(pagination.value?.totalEntries || 0) + " entri ", 1),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              class: "rounded-l-lg border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value <= 1,
              onClick: _cache[5] || (_cache[5] = () => { page.value = (pagination.value?.currentPage || 1) - 1; getData(); })
            }, " Sebelumnya ", 8, _hoisted_50),
            _createElementVNode("button", {
              class: "rounded-r-lg border-y border-r border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40",
              disabled: page.value >= (pagination.value?.totalPages || 1),
              onClick: _cache[6] || (_cache[6] = () => { page.value = (pagination.value?.currentPage || 1) + 1; getData(); })
            }, " Berikutnya ", 8, _hoisted_51)
          ])
        ])
      ])
    ])
  ]))
}
}

})